import './common/sass/index.scss';
import './common/sass/scence.scss';
import {init} from './common/js/init.js';

init();



// WEBPACK FOOTER //
// ./src/app.js